<template>
    <div class="anchor-container">
      <!-- <search-card /> -->
<!--      <table-card style="margin-top:30px" />-->
      <iframe style="border:0px;border-radius:10px;width: 1500px;height: 800px;"
              :src="iframeSrc"
      ></iframe>
    </div>
</template>

<script>


export default {
  name: "anchor",
  components: {
    // searchCard,
  },
  data() {
    return {
      iframeSrc: ''
    };
  },
  computed: {
  },
  mounted(){
    const token = localStorage.getItem('token');
    if (token) {
      // 构造带有 token 的 iframe src
      this.iframeSrc = `https://web-1305060147.cos.ap-chengdu.myqcloud.com/javascript/anchor-list.html?token=${token}`;
    }
  },
  methods: {

  }
};
</script>

<style lang="less" scoped>
.anchor-container {
  width: 100%;
}
</style>
